import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

type LocalState = { q: string | null };

export function useLocalState(defaultState?: Partial<LocalState>) {
  const [searchParams] = useSearchParams();
  const [localState, setLocalState] = useState<LocalState>({
    q: (defaultState && defaultState.q) || searchParams.get('q')
  });

  const queryParams = useMemo(() => {
    return {
      q: localState.q
    };
  }, [localState]);

  useEffect(() => {
    const qFromUrl = searchParams.get('q');

    if (!qFromUrl) return;

    setLocalState((prev) =>
      prev.q === qFromUrl ? prev : { ...prev, q: qFromUrl }
    );
  }, [searchParams]);

  return {
    localState,
    queryParams
  };
}

export function searchStateToParams(state: any) {
  return { unique_identifier: state.q } as any;
}
